import { signal } from "@preact-signals/safe-react";
export const userPermissions$ = signal(null);
export const isImpersonating$ = signal(false);
//# sourceMappingURL=permissions.js.map